import React, { useEffect } from 'react'
import * as Highcharts from 'highcharts'
import { HighchartsReact } from 'highcharts-react-official';
import { useAppDispatch, useAppSelector } from '../../store/storeRequests';
import StoreSelectors from '../../utils/constants/StoreSelectors.constants';
import { useLocation } from 'react-router-dom';
import { setInitLineChart, setInitPieChart } from '../../store/chartState/chartState.slice';
import './custom-charts.css'

const CustomCharts: React.FunctionComponent<{ chartType: 'pie' | 'line', chartLabels?: Array<any>, chartValues: Array<any> }> = ({ chartType, chartLabels, chartValues }) => {

    const { healthChartData, initPieChart, initLineChart } = useAppSelector(StoreSelectors.CHART_STATE)

    const location = useLocation()
    const dispatch = useAppDispatch()

    const lineChartOptions: Highcharts.Options = {
        chart: {
            type: 'spline'
        },
        colors: ['#071d3d'],
        title: { text: '' },
        legend: { accessibility: { enabled: false } },
        xAxis: {
            title: { text: '' },
            // type: 'category',
            categories: chartLabels
        },
        tooltip: {
            borderColor: '#2c3e50',
            shared: true,
            useHTML: true,
            formatter: function (tooltip) {
                const point: any = this.point
                const header = `
                <div class="mf-line-custom-tooltip mb-0">
                    <span class="line-custom-tooltip-leading"><strong>${point.y}</strong> Total Hits</span><br/>
                    <pre class="line-custom-tooltip-item tooltip-success ps-0 ms-0 mb-0">${point.success} success</pre><br/>
                    <pre class="line-custom-tooltip-item tooltip-failure ps-0 ms-0 mb-0 mt-0">${point.failure} failure</pre><br/>
                </div>
                `
              return header
            }
        },
    
        yAxis: {
            title: { text: 'API Consumption' }
        },
        accessibility: {
            screenReaderSection: {
              beforeChartFormat: "",
            },
        },
        credits: { enabled: false }
    };
    

    let pieChartOptions: Highcharts.Options = {
        colors: ['#3CC673', '#FF9F9F'],
        title: { text: '' },
        subtitle: {
            text: `<p class="pie-chart-middle-text"><strong>${ healthChartData.total }</strong> total hits</p>`,
            align: 'center',
            verticalAlign: 'middle',
            useHTML: true,
        },
        legend: { accessibility: { enabled: false } },
        accessibility: {
            screenReaderSection: {
              beforeChartFormat: "",
            },
        },
        credits: { enabled: false }
    };

    useEffect(() => {
        if (location.pathname.includes('live')) {
            dispatch(setInitLineChart(false))
            dispatch(setInitPieChart(false))
        }
    }, [location])
    
  return (
    <div className="mf-custom-charts">
        {
            chartType === 'line' && initLineChart &&
            <HighchartsReact
                highcharts={Highcharts}
                options={{
                    ...lineChartOptions,
                    series: [{
                        name: 'Consumption',
                        type: 'spline',
                        data: chartValues,
                        showInLegend: false
                
                    }]
                }}
                className='mf-line-chart'
                { ...HighchartsReact.defaultProps }
            />
        }
        {
            chartType === 'pie' && initPieChart &&
            <HighchartsReact
                highcharts={Highcharts}
                options={{ 
                    ...pieChartOptions,
                    series: [{
                        name: 'Consumption',
                        type: 'pie',
                        data: healthChartData.data,
                        showInLegend: false,
                        innerSize: '50%'
                    }]
                }}
                className='mf-pie-chart'
                { ...HighchartsReact.defaultProps }
            />
        }
    </div>
  )
}

export default CustomCharts